import { Modal } from 'antd';
import React from 'react';

import { translate } from '@portal/services/i18n';

import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';

interface MaintenanceModalProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

const MaintenanceModal = ({ setVisible, visible }: MaintenanceModalProps) => {
  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <Modal open={visible} footer={null} onCancel={handleCancel}>
      <div className="modal-maintenance">
        <h1 className="modal-maintenance__title">
          {translate('COMPONENTS.MAINTENANCE.TITLE')}
        </h1>
        <p className="modal-maintenance__description">
          {translate('COMPONENTS.MAINTENANCE.DESCRIPTION')}
        </p>
        <AdvancedButton
          text={translate('COMPONENTS.MAINTENANCE.OK')}
          onClick={handleCancel}
        />
      </div>
    </Modal>
  );
};

export default MaintenanceModal;
